import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut, 
  sendEmailVerification, 
  onAuthStateChanged,
  updateProfile,
  sendPasswordResetEmail,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider
} from 'firebase/auth';
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBbBs8qdJwCopXq3NVZssrMxOR-hUC7xVQ",
  authDomain: "mr-excel-sri-lanka-web.firebaseapp.com",
  projectId: "mr-excel-sri-lanka-web",
  storageBucket: "mr-excel-sri-lanka-web.firebasestorage.app",
  messagingSenderId: "233880602325",
  appId: "1:233880602325:web:573e3ba36cb1dfb5e3445c",
  measurementId: "G-G7JLJF2G3Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

export {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  onAuthStateChanged,
  updateProfile,
  sendPasswordResetEmail,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  collection,
  addDoc,
  serverTimestamp
};
